export default function MentionsLegales() {
  return (
    <div data-testid="mentions-legales" className="pt-32 pb-20 bg-bone">
      <div className="container-max max-w-3xl">
        <p className="overline">— Mentions légales</p>
        <h1 className="font-display font-light text-5xl md:text-7xl mt-4">Informations légales</h1>
        <div className="mt-12 space-y-8 text-ink/80 leading-relaxed">
          <section>
            <h2 className="font-display text-2xl text-ink mb-2">Éditeur</h2>
            <p>MAISON FAUBOURG SAS — 27 rue du Faubourg Saint-Honoré, 75008 Paris<br />
              SIRET 912 456 789 00012 — RCS Paris<br />
              Capital social : 50 000 € — TVA intracommunautaire : FR12 912456789</p>
          </section>
          <section>
            <h2 className="font-display text-2xl text-ink mb-2">Directeur de la publication</h2>
            <p>L'équipe MAISON FAUBOURG</p>
          </section>
          <section>
            <h2 className="font-display text-2xl text-ink mb-2">Hébergement</h2>
            <p>Service hébergé sur infrastructure Emergent (https://emergent.sh)</p>
          </section>
          <section>
            <h2 className="font-display text-2xl text-ink mb-2">Données personnelles</h2>
            <p>Les informations transmises via les formulaires sont strictement confidentielles et utilisées exclusivement pour vous recontacter. Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression sur simple demande à atelier@maison-faubourg.fr.</p>
          </section>
          <section>
            <h2 className="font-display text-2xl text-ink mb-2">Assurances</h2>
            <p>Décennale n° MMA 142.388.012 — Responsabilité civile professionnelle MMA 09/2024.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
